import * as React from 'react'
import { EndProgressItemProps } from './typings'

export const SingleProgressNode: React.FC<EndProgressItemProps> = (
  props: EndProgressItemProps,
) => {
  const {
    color = '#18325A',
    height = 33,
    radius = 4,
    width = 400,
    transitionTime = 0.5,
  } = props

  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      enableBackground={`new 0 0 ${width} ${height}`}
      xmlSpace="preserve"
    >
      <path
        style={{
          fill: color,
          transition: `fill ${transitionTime}s`,
        }}
        d={`M${radius},${height}c-${radius / 2},0-${radius}-${
          radius / 2
        }-${radius}-${radius}V${radius}c0-${radius / 2},${
          radius / 2
        }-${radius},${radius}-${radius}h${width - radius * 2}c${
          radius / 2
        },0,${radius},${radius / 2},${radius},${radius}v${height - radius * 2}
        c0,${radius / 2}-${
          radius / 2
        },${radius}-${radius},${radius}H${radius}z`}
      />
    </svg>
  )
}
SingleProgressNode.displayName = 'SingleProgressNode'
